import { BooleanFilterEnum } from '../../../enums/boolean-filter.enum';
import { ApiRequestFilters } from '../../../types/api-request-filters';
import { AreaTypeEnum } from '../enums/area-type.enum';

/**
 * Area filters
 */
export class AreasFilters extends ApiRequestFilters {
	/**
	 * Country
	 */
	countryId?: number;

	/**
	 * Area type values
	 */
	types?: AreaTypeEnum[];

	/**
	 * Hidden value
	 */
	hidden?: BooleanFilterEnum;
}
